import * as ko from "knockout";

import { HtmlDialog, type HtmlDialogParams } from "../lib/popups";

/** Create a dialog starter function from the given model and template.
 *
 * Same as the other dialogStarter, but with HtmlDialog as base class.
 */
export const htmlDialogStarter = <Model, Params, ConstructorParams>(
    viewModel: { new (dialog: HtmlDialog, params: Params, constructorParams: ConstructorParams): Model },
    template: string | Promise<typeof import("*.html")>,
    config: HtmlDialogParams | ((params: Params, constructorParams: ConstructorParams) => HtmlDialogParams) = {},
    constructorParams?: ConstructorParams,
): ((params: Params) => Model) => {
    return (params): Model => {
        const container = document.createElement("div");

        let dialog: HtmlDialog;
        if (typeof config === "function") {
            dialog = new HtmlDialog(container, config(params, constructorParams));
        } else {
            dialog = new HtmlDialog(container, config);
        }
        const model = new viewModel(dialog, params, constructorParams);
        if (template instanceof Promise) {
            template.then((template) => {
                container.innerHTML = template.default;
                ko.applyBindings(model, container);
            });
        } else {
            container.innerHTML = template;
            ko.applyBindings(model, container);
        }
        dialog.addOnClose(() => {
            ko.cleanNode(container);
        });
        return model;
    };
};
